module.exports = __webpack_public_path__ + "static/img/profile3.f693acad.jpg";